// extracted by mini-css-extract-plugin
export var hidden = "_4z-1";
export var leftPanel = "_4z-2";
export var readonlyInspector = "_4z-3";
export var rightPanel = "_4z-0";